import React, { FC, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { UserImage } from '../../../components/UserImage';
import { userLinkLoadUserImage } from '../actions';
import { userLinkUserImageSelector } from '../selectors';

interface LoadUserImageProps {
    userId: string;
    width?: number;
    height?: number;
    className?: string;
}

export const LoadUserImage: FC<LoadUserImageProps> = (props) => {

    const dispatch = useDispatch();
    const imageId = useSelector(userLinkUserImageSelector(props.userId));

    useEffect(() => {
        if (props.userId) {
            dispatch(userLinkLoadUserImage(props.userId));
        }
    }, [props.userId, dispatch]);

    return (
        <>
            <UserImage imageId={imageId} width={props.width} height={props.height} className={props.className}/>
        </>
    )
}